import { useState } from 'react';
import { db } from '@/lib/db';
import { Sheet } from '@/components/shared/Sheet';

interface Props {
  onClose: () => void;
  onLogged: () => void;
}

export function GivingLogSheet({ onClose, onLogged }: Props) {
  const [amount, setAmount] = useState('');
  const [note, setNote] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    const dollars = parseFloat(amount);
    if (!dollars || dollars <= 0) return;
    setSubmitting(true);
    try {
      await db.donations.log({ amount_cents: Math.round(dollars * 100), venmo_note: note.trim() || undefined });
      onLogged();
      onClose();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Sheet title="Log Donation" onClose={onClose}>
      <div className="px-4 pb-6 pt-2">
        <div className="mb-4 text-xs leading-[1.5] text-ink-soft">
          Self-report charitable giving. Bag Tag does not process payments.
        </div>
        <div className="mb-3.5">
          <div className="mb-1.5 text-[10px] font-bold tracking-[0.15em] text-mute">AMOUNT</div>
          <input
            type="number"
            step="0.01"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="0.00"
            className="w-full rounded-[10px] border border-line bg-cream px-3.5 py-3 text-center font-serif text-2xl font-bold text-navy outline-none"
          />
        </div>
        <div className="mb-4">
          <div className="mb-1.5 text-[10px] font-bold tracking-[0.15em] text-mute">NOTE (OPTIONAL)</div>
          <input
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="e.g. ANCC Foundation"
            className="w-full rounded-[10px] border border-line bg-cream px-3.5 py-3 text-sm text-ink outline-none"
          />
        </div>
        <div className="flex gap-2.5">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 rounded-[10px] border border-line bg-paper py-3 text-[13px] font-bold text-ink"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => void submit()}
            disabled={submitting || !amount || parseFloat(amount) <= 0}
            className="flex-[1.5] rounded-[10px] bg-navy py-3 text-[13px] font-bold text-paper disabled:opacity-50"
          >
            {submitting ? 'Saving…' : 'Log Donation'}
          </button>
        </div>
      </div>
    </Sheet>
  );
}
